import { render, staticRenderFns } from "./EducationModalForm.vue?vue&type=template&id=180a1c76"
import script from "./EducationModalForm.vue?vue&type=script&lang=js"
export * from "./EducationModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports